export default __webpack_public_path__ + "static/media/Trust.27878cd7.jpg";